/**
 * Created by laugh on 12/18/2017.
 */
import React, { Component } from 'react';
import $ from 'jquery';
import logo from '../../assets/img/mealtrist-logo.png';
import { Link } from 'react-router-dom';
import MainHeader from '../header';
import MealtristHeader from '../Core/mealtristHeader';
import {FormGroup} from 'react-bootstrap';
import * as ReactBootstrap from 'react-bootstrap';
import StackGrid from "react-stack-grid";
import mealpic from '../../assets/img/mealtrist-featured-meal.jpg'
import '../../App.css';
import 'font-awesome/css/font-awesome.css';
import sizeMe from 'react-sizeme';
import swal from 'sweetalert';
import MealtristFeed from '../../components/Core/footer';
import MealtristFooter from "../Core/mealtrist-footer";

import axios from 'axios';

class Feed extends React.Component {
    constructor(props) {
        super(props);
        this.state = {email: "", password: "", grid: "", meals: "", search: "", filterSelect: "All", loggedIn: true, savedMeal: "", redirecting: false, provider: "cox", leadSource: "500", tfn: "772-452-4565", text: "The TransactionID is "};
        this.handleChange = this.handleChange.bind(this);
        this.handlePassword = this.handlePassword.bind(this);
        this.login = this.login.bind(this);
        this.createMarkup = this.createMarkup.bind(this);
        this.onSelectAlert = this.onSelectAlert.bind(this);
        this.capitalizeWords = this.capitalizeWords.bind(this);
        this.saveMeal = this.saveMeal.bind(this);
    }

    handleChange(event) {
        this.setState({search: event.target.value.toLowerCase()});
    }

    onSelectAlert(eventKey) {
        this.setState({filterSelect: eventKey });
    }

    handlePassword(e) {
        this.setState({password: e.target.value});
    }

    capitalizeWords(str)
    {
        return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    }

    saveMeal(id)
    {
        var globalThis = this;
        const user = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            phoneNumber: this.state.phoneNumber,
            token: ""
        };

        user.token = localStorage.getItem("mealToken");
        if(user.token != "" ) {
            //TESTING COMPLETE ORDERS
            $.ajax({
                url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                type: 'get',
                async: false,
                'headers': {
                    // Use access_token previously retrieved from inContact token
                    // service.
                    'Authorization': 'Bearer ' + user.token,
                },
                error: function (response) {
                    //Failed response
                    // logOrderError(visitID, 'otsError', completeOrderData, response);
                },
                success: function (response) {
                    if(typeof(response.message) !== 'undefined') {
                        if(response.message.indexOf('authenticated_user') > -1) {
                            if (typeof(response.data) !== 'undefined') {
                                $.ajax({
                                    url: process.env.REACT_APP_API_HOST + '/' + 'api/meal/save/' + id,
                                    type: 'post',
                                    async: false,
                                    'headers': {
                                        // Use access_token previously retrieved from inContact token
                                        // service.
                                        'Authorization': 'Bearer ' + user.token,
                                    },
                                    error: function (response) {
                                        //Failed response
                                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                                    },
                                    success: function (response) {
                                        swal("Meal Saved!", {
                                            buttons: false,
                                            icon: "success",
                                            timer: 2000,
                                        });
                                        console.log(response);
                                        if(typeof(response) !== 'undefined') {
                                            globalThis.setState(prevState => ({
                                                savedMeal: response
                                            }));
                                        }
                                    }
                                });
                            }
                        }
                    }
                }
            });
        }
    }

    login(e) {
        const customer = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            phoneNumber: this.state.phoneNumber
        };

        $.ajax({
            url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/login',
            type: 'post',
            async: false,
            data: {
                email: this.state.email,
                password: this.state.password
            },
            error: function (response) {
                //Failed response
                // logOrderError(visitID, 'otsError', completeOrderData, response);
            },
            success: function (response) {
                console.log(response);
                // this.setState(prevState => ({
                //     redirecting: <Redirect to="/confirmation"/>
                // }));
            }
        });

    }

    createMarkup(text) {
        return {__html: text};
    }

    componentDidMount() {
        // if(this.state.provider != "") {
        //     require('../assets/css/' + this.state.provider + '.css');
        // }
        var globalThis = this;
        const user = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            phoneNumber: this.state.phoneNumber,
            token: ""
        };

        user.token = localStorage.getItem("mealToken");
        if(user.token != "" ) {
            axios.get(process.env.REACT_APP_API_HOST + '/' + 'api/auth/user', {
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            })
                .then(function (response) {
                    response = response.data;
                    if(typeof(response.message) !== 'undefined') {
                        if(response.message.indexOf('authenticated_user') > -1) {
                            if (typeof(response.data) !== 'undefined') {
                                if (typeof(response.data.id) !== 'undefined') {

                                } else {
                                    globalThis.setState(prevState => ({
                                        loggedIn: false
                                    }));
                                }
                                $.ajax({
                                    url: process.env.REACT_APP_API_HOST + '/' + 'api/mealtrist/feed/' + response.data.id,
                                    type: 'post',
                                    async: false,
                                    'headers': {
                                        // Use access_token previously retrieved from inContact token
                                        // service.
                                        'Authorization': 'Bearer ' + user.token,
                                    },
                                    error: function (response) {
                                        //Failed response
                                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                                    },
                                    success: function (response) {
                                        console.log(response);
                                        if(typeof(response) !== 'undefined') {
                                            if(response.meals.length !== 0) {
                                                globalThis.setState(prevState => ({
                                                    meals: response.meals
                                                }));
                                            } else {
                                                globalThis.setState(prevState => ({
                                                    meals: "no meals"
                                                }));
                                            }
                                        }
                                    }
                                });
                            }
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }

    }

    //TODO set referrer url link in containers first child link
    render() {
        console.log('in feed');
        const { width, height } = this.props.size;
        const grid = {
            update: ""
        }
        const fakeArr = ["d", "a"];
        const pictures = fakeArr.map((imgPath, pathIndex) => {
            return  <div key={imgPath}><img src="https://tsuyoshiwada.github.io/react-stack-grid/images/photos/photo03.jpg" /></div>
        });
        const header = {
            use: ""
        }
        if(this.state.loggedIn === true) {
            header.use = <MealtristHeader/>;
        } else {
            header.use = <MainHeader/>;
        }

        let output =
            <div>
                {header.use}
                <div className="text-center main-body-content">
                    <i className="fa fa-spinner fa-pulse fa-3x fa-fw loading-logo"></i>
                </div>
                <MealtristFooter/>
            </div>
            if(this.state.meals != "" && this.state.meals !== 'no meals') {
                let filteredMeals = this.state.meals.filter((meal) => meal.name.toLowerCase().indexOf(this.state.search) > -1);
                if(this.state.filterSelect.toLowerCase() !== "all") {
                    console.log("in first");
                    console.log(this.state.filterSelect);
                    filteredMeals = filteredMeals.filter((meal) => meal.course.toLowerCase().indexOf(this.state.filterSelect) > -1);
                } else {
                    console.log(this.state.filterSelect);
                    console.log("filtered");
                    filteredMeals = filteredMeals.filter((meal) => meal.course !== "");
                }
                const mealsData = filteredMeals .map((meal, mealIndex) => {
                    return  <div key={mealIndex}>
                        <img className="center-block img-responsive" src={ meal.picture} />
                        <h4 className="text-center"><Link to={'meal-show/' + meal.id}>{meal.name}</Link></h4>
                        <p dangerouslySetInnerHTML={this.createMarkup(meal.description)}></p>
                        <ReactBootstrap.ButtonToolbar>
                            <ReactBootstrap.Button className="center-important" onClick={this.saveMeal.bind(this, meal.id)}>Save Meal</ReactBootstrap.Button>
                        </ReactBootstrap.ButtonToolbar>
                        <br></br>
                    </div>
                });
                console.log("print meals");
                console.log(this.state.meals);
                output = <div>
                    <div className="container main-body-content">
                        {header.use}
                        <div className="row">
                            <div className="col-xs-6">
                                <ReactBootstrap.Form horizontal>
                                    <ReactBootstrap.FormGroup bsSize="large" controlId="formHorizontalEmail">
                                    <ReactBootstrap.FormControl type="text" value={this.state.search} onChange={this.handleChange} placeholder="Search Meals" />
                                    </ReactBootstrap.FormGroup>
                                </ReactBootstrap.Form>
                            </div>
                            <div className="col-xs-6">
                                <ReactBootstrap.Form horizontal>
                                    <ReactBootstrap.FormGroup bsSize="large" controlId="formHorizontalEmail">
                                        <ReactBootstrap.SplitButton title={this.capitalizeWords(this.state.filterSelect)} pullRight id="split-button-pull-right" bsSize="large">
                                        <ReactBootstrap.MenuItem eventKey={'all'} onSelect={this.onSelectAlert}>All</ReactBootstrap.MenuItem>
                                        <ReactBootstrap.MenuItem eventKey="main dishes" onSelect={this.onSelectAlert}>Main Dishes</ReactBootstrap.MenuItem>
                                        <ReactBootstrap.MenuItem eventKey="appetizer" onSelect={this.onSelectAlert}>Appetizer</ReactBootstrap.MenuItem>
                                        <ReactBootstrap.MenuItem eventKey="beverages" onSelect={this.onSelectAlert}>Beverages</ReactBootstrap.MenuItem>
                                        <ReactBootstrap.MenuItem eventKey="breads" onSelect={this.onSelectAlert}>Breads</ReactBootstrap.MenuItem>
                                        <ReactBootstrap.MenuItem eventKey="desserts" onSelect={this.onSelectAlert}>Desserts</ReactBootstrap.MenuItem>
                                        <ReactBootstrap.MenuItem eventKey="finger foods" onSelect={this.onSelectAlert}>Finger Foods</ReactBootstrap.MenuItem>
                                        <ReactBootstrap.MenuItem eventKey="salads" onSelect={this.onSelectAlert}>Salads</ReactBootstrap.MenuItem>
                                        <ReactBootstrap.MenuItem eventKey="side dishes" onSelect={this.onSelectAlert}>Side Dishes</ReactBootstrap.MenuItem>
                                        <ReactBootstrap.MenuItem eventKey="snacks" onSelect={this.onSelectAlert}>Snacks</ReactBootstrap.MenuItem>
                                        <ReactBootstrap.MenuItem eventKey="soups and stew" onSelect={this.onSelectAlert}>Soups & Stew</ReactBootstrap.MenuItem>
                                        <ReactBootstrap.MenuItem divider />
                                        <ReactBootstrap.MenuItem eventKey="4">Separated link</ReactBootstrap.MenuItem>
                                    </ReactBootstrap.SplitButton>
                                    </ReactBootstrap.FormGroup>
                                </ReactBootstrap.Form>
                            </div>
                        </div>
                <StackGrid
                    columnWidth={width <= 768 ? '50%' : '25%' || '25%'}
                    monitorImagesLoaded="{true}"
                    // duration={0}
                >
                    {mealsData}
                </StackGrid>
                    </div>
                    <MealtristFooter/>
                </div>
            } else if(this.state.meals === 'no meals') {
                 output =
                    <div>
                        {header.use}
                        <div className="main-body-content text-center">
                            <h2>No meals available - Make connections to have meals in feed</h2>
                        </div>
                        <MealtristFooter/>
                    </div>
            }
        // console.log("print grid");
        // console.log(grid.update);
        // if(grid.update !== "") {
        //     console.log("grid updating");
        //     console.log(grid.update);
        //     grid.update.updateLayout();
        // }
        return (
                output
        );
    }
}

export default sizeMe()(Feed);


// WEBPACK FOOTER //
// ./src/components/Mealtrist/feed.js